/**
 * Environment detection and indicators from the current URL/host
 */

export type Environment =
  | 'local'
  | 'smrx-dev'
  | 'smrx-qa'
  | 'smrx-preprod'
  | 'production';

export function determineCurrentEnvironment(): Environment {
  const hostname = window?.location?.hostname ?? '';

  if (/(localhost|local\.mysmithrx\.com)$/.test(hostname)) {
    return 'local';
  }

  if (/smrx-dev\.com$/.test(hostname)) {
    return 'smrx-dev';
  }

  if (/smrx-qa\.com$/.test(hostname)) {
    return 'smrx-qa';
  }

  if (/smrx-preprod\.com$/.test(hostname)) {
    return 'smrx-preprod';
  }

  if (/(smrx-prod\.com|mysmithrx\.com)$/.test(hostname)) {
    return 'production';
  }

  throw new Error('Unknown environment');
}

export const environmentIndicator = (function getEnvironmentIndicator() {
  switch (determineCurrentEnvironment()) {
    case 'smrx-qa':
      return 'QA';
    case 'smrx-preprod':
      return 'Preprod';
    case 'smrx-dev':
      return 'Dev';
    case 'local':
      return 'Local->Dev';
    case 'production':
    default:
      return null;
  }
})();

export const datadogEnvironment = (function getDatadogEnvironment() {
  switch (determineCurrentEnvironment()) {
    case 'smrx-qa':
      return 'qa';
    case 'smrx-preprod':
      return 'preprod';
    case 'production':
      return 'production';
    case 'local':
    case 'smrx-dev':
    default:
      return null;
  }
})();
